module.exports = __webpack_public_path__ + "img/2.bcc6fdb5.webp";